export const closeVehiclePopout = (
  id,
  {
    removeBox,
    removeLayerOnClose,
    setShowDetails,
    removeRowSelection,
    setDeviceId,
    setSelectedVehiclePlate,
    setVehicleData,
    setShowTrack,
    setDockAlign,
    setCurrentTab,
  },
) => {
  removeBox(id);
  removeLayerOnClose();
  setShowDetails(false);
  removeRowSelection();
  setDeviceId(null);
  setSelectedVehiclePlate(null);
  setVehicleData(null);
  setShowTrack(false);
  setDockAlign("cross");
  setCurrentTab("Map");
};
